import styled from '@emotion/styled';

const PopoverContainer = styled.div`
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 4px;
    padding-bottom: 4px;
    background: #202126;
    border-radius: 8px;
    overflow: hidden;
    justify-content: flex-start;
    align-items: center;
    display: flex;
    margin-bottom: 4px;
`;

const TextWrapper = styled.div`
    color: white;
    font-size: 12px;
    font-weight: 500;
    line-height: 19.92px;
    word-wrap: break-word;
`;

export const UnpublishedPopover = () => {
    return (
        <PopoverContainer>
            <TextWrapper>Completed project</TextWrapper>
        </PopoverContainer>
    );
};
